import { supabase } from './supabase'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = (t: string): any => (supabase as any).from(t)

export async function logAction(params: {
  tenantId: string
  userId: string
  action: string
  module: string
  resourceType: string
  resourceId?: string
  description: string
  oldValues?: Record<string, unknown>
  newValues?: Record<string, unknown>
}) {
  try {
    await db('audit_logs').insert({
      tenant_id: params.tenantId,
      user_id: params.userId,
      action: params.action.toLowerCase(),
      table_name: params.module,
      resource_type: params.resourceType,
      resource_id: params.resourceId ?? null,
      description: params.description,
      before_data: params.oldValues ?? null,
      after_data: params.newValues ?? null,
      created_at: new Date().toISOString(),
    })
  } catch {
    // Never throw — audit failures must not break the app
  }
}

// Login/logout audit — writes the rows the Audit page's login/logout tabs already
// read (action IN ('login','logout')). The logout `kind` lives in `description`
// ("Signed out" vs "Session expired") since audit_logs has no kind column. On logout
// the caller MUST await this before signOut(), or the session is gone before the
// insert (RLS needs the authenticated tenant). Best-effort: a browser close won't
// record a logout — that's an accepted limitation.
export async function logAuthEvent(
  tenantId: string | null | undefined,
  userId: string | null | undefined,
  event: 'login' | 'logout',
  description: string,
) {
  if (!tenantId || !userId) return
  try {
    await db('audit_logs').insert({
      tenant_id: tenantId,
      user_id: userId,
      action: event,
      table_name: 'auth',
      resource_type: 'auth',
      description,
      created_at: new Date().toISOString(),
    })
  } catch {
    // Never throw — audit failures must not break sign-in/out
  }
}
